module.exports = __webpack_public_path__ + "media/images/85/insomnia_moon_dark_skies-f645af499c86611990b13976597c47d0.webp";